// Stripe Integration for Template Sales
(function() {
  const STRIPE_PUBLIC_KEY = window.stripePublicKey || 'pk_test_your_key_here';

  let stripePromise = null;

  function loadStripe() {
    if (stripePromise) return stripePromise;
    stripePromise = new Promise((resolve, reject) => {
      if (window.Stripe) {
        resolve(window.Stripe);
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://js.stripe.com/v3/';
      script.async = true;
      script.onload = () => resolve(window.Stripe);
      script.onerror = () => reject(new Error('Failed to load Stripe'));
      document.head.appendChild(script);
    });
    return stripePromise;
  }

  let stripeInstance = null;
  async function getStripe() {
    if (stripeInstance) return stripeInstance;
    const StripeAPI = await loadStripe();
    stripeInstance = StripeAPI(STRIPE_PUBLIC_KEY);
    return stripeInstance;
  }

  // Initialize Stripe Checkout
  window.stripeCheckout = {
    redirectToCheckout: async function(options) {
      const priceId = options.priceId;
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: priceId,
              quantity: 1
            }]
          })
        });

        if (response.ok) {
          // Redirect to checkout
          window.location.href = '/checkout';
        }
      } catch (error) {
        console.error('Checkout error:', error);
      }
    },

    // Alternative: Direct Stripe Checkout (requires session endpoint)
    directCheckout: async function(priceId) {
      try {
        const stripe = await getStripe();

        const response = await fetch('/api/create-checkout-session', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            priceId: priceId
          })
        });

        const session = await response.json();
        
        const result = await stripe.redirectToCheckout({
          sessionId: session.id
        });

        if (result.error) {
          console.error(result.error.message);
        }
      } catch (error) {
        console.error('Error:', error);
      }
    }
  };

  // Payment request button
  window.stripePaymentRequest = {
    create: async function(priceId) {
      const stripe = await getStripe();
      const paymentRequest = stripe.paymentRequest({
        country: 'US',
        currency: 'usd',
        total: {
          label: 'Template Purchase',
          amount: 0 // Amount should be set based on price
        },
        requestPayerName: true,
        requestPayerEmail: true,
      });

      const elements = stripe.elements();
      const prButton = elements.create('paymentRequestButton', {
        paymentRequest: paymentRequest,
      });

      paymentRequest.canMakePayment().then(result => {
        if (result) {
          prButton.mount('#payment-request-button');
        }
      });

      return paymentRequest;
    }
  };

  // Handle payment success
  document.addEventListener('DOMContentLoaded', function() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('session_id')) {
      // Payment was successful, show success message
      console.log('Payment successful');
    }
  });
})();
